export default __webpack_public_path__ + "static/vanilla-glaze-doughnut1-722668126bb199164272725fe57a5c98.png";